import * as React from 'react';
import { Client as StyletronClient } from 'styletron-engine-atomic';
import { DebugEngine, Provider as StyletronProvider } from 'styletron-react';

import { STYLETRON_PREFIX, wrapPageElement, wrapRootElement as wrapWithRedux } from './gatsby-shared';

export { wrapPageElement };

const debugEngine = process.env.NODE_ENV !== 'production' ? new DebugEngine() : undefined;

// NOTE: use React.createElement, not JSX. Gatsby compiles these root files with the
// classic JSX runtime (-> React.createElement), but eslint-config-react-app treats the
// React import as unused and strips it, causing `React is not defined` at runtime, which
// crashes hydration (page looks styled from SSR, but nothing is clickable). Referencing
// React.createElement explicitly keeps the import alive.
export function wrapRootElement(args) {
  const hydrateElements =
    typeof document !== 'undefined' ? document.querySelectorAll('._styletron_hydrate_') : undefined;
  const engine = new StyletronClient({ hydrate: hydrateElements, prefix: STYLETRON_PREFIX });

  return React.createElement(
    StyletronProvider,
    { value: engine, debugMode: debugEngine, debugAfterHydration: Boolean(debugEngine) },
    wrapWithRedux(args),
  );
}
